import type { KyInstance } from 'ky';

import { ensureError, MINUTE } from '@enterprise/core';
import type { FileUpload } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Uploads one or more external LOL (List of Lists) files to the server using the provided Ky HTTP client instance.
 *
 * Each file upload includes its associated metadata, with the file size automatically added to the metadata.
 * The files and their metadata are sent as multipart/form-data in the request body.
 *
 * @param instance - The KyInstance HTTP client used to make the POST request.
 * @param fileUploads - An array of FileUpload objects, each containing a file and its metadata.
 * @returns A promise that resolves with the server's JSON response.
 * @throws Throws an error if the upload fails.
 */
export const uploadExternalLol = async (instance: KyInstance, fileUploads: FileUpload[]) => {
  try {
    const formData = new FormData();

    for (const { file, metaData } of fileUploads) {
      formData.append('metaData', JSON.stringify({ ...metaData, fileSize: file.size }));
      formData.append('file', file);
    }

    return await instance
      .extend({
        retry: 0,
        timeout: 5 * MINUTE,
      })
      .post(Uri.files.externalLol, { body: formData })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
